<template>
  <div class="groups bg-white h-full">

    <FilterBar @searchChanged="setSearchValue">
      <template v-slot:filter>
        <div>
        </div>
        <div>

        </div>
      </template>
    </FilterBar>

    <div v-if="errored" class="empty">
      <p>
        We are not able to retrieve this information at the moment, please try
        back later
      </p>
    </div>

    <div id="content-area" v-else>
      <div
        style="width: 100%; text-align: center"
        class="spin-holder mt-4"
        v-if="loading"
      >
        <i class="spinner fa fa-spinner fa-spin"></i>
        <p>Loading Groups</p>
      </div>

      <div v-else>
        <table
          class="
           w-8/12
            ml-8
            mb-2
            h-10
            pt-2
            align-text-bottom
            bg-white
            rounded
            text-left text-gray-600
          "
        >
          <thead class="bg-gray-100  w-full">
            <tr>
              <th class="w-2/12 px-3">Type</th>
              <th class="w-5/12 pl-3">Title</th>
              <th class="w-1/12">Info</th>
              <th class="w-1/12 px-3"></th>
            </tr>
          </thead>
        </table>

        <table class="table-wrapper w-8/12 bg-white  ml-8 rounded shadow-sm">
          <tbody>
            <tr v-for="group in filteredList" :key="group.identifier">
              <td class="w-2/12 pr-3 capitalize">{{group.type.title}}</td>
              <td class="w-5/12 font-semibold">{{ group.title }}</td>
              <td class="w-1/12 center">
                <span @click="openInfo(group)" v-if="groupHasFile(group)"><i class="fas fa-file-pdf text-xl text-blue-400 cursor-pointer"></i></span>
                <span v-else>n/a</span>
              </td>
              <td class="w-1/12">
                <a
                  v-if="shouldDisplay()"
                  @click="showGroupDisplay(group)"
                  class="button special small cursor-pointer hover:opacity-50"
                  >View</a
                >

                  <i v-else class="fas fa-lock text-yellow-500 text-lg pl-2"></i>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="m-4 text-gray-500 pt-2 pl-5">
          Showing {{ filteredList.length }} groups
        </div>
      </div>
    </div>

    <ModalFile
      :url="selectedGroup.file_url"
      :title="selectedGroup.title"
      :format="'taskgroup'"
      @close="showModalFile = false"
      v-if="selectedGroup.id != undefined && showModalFile"
      v-show="showModalFile"
    ></ModalFile>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { TaskService } from "@/services/task.service";
import { upgradeMixin } from "@/mixins/upgradeMixin.js";

const UpgradeModal = () => import("@/components/upgrade/UpgradeModal.vue");
const Dropdown = () => import("@/components/Dropdown.vue");
const FilterBar = () => import("@/components/FilterBarNavigation.vue");
const ModalFile = () => import("@/components/ModalFile.vue");

export default {
  name: "videos",
    mixins: [upgradeMixin],
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
    }),
    componentLoaded() {
      return this.groups.length > 0;
    },
    typeDropdown() {
      return this.typeList;
    },
    orderedGroups() {
      return _.orderBy(this.groups, ["title"]);
    },
    filteredList() {
      var vm = this;
      return this.orderedGroups.filter((item) => {
        let filtered = true;

        if (filtered) {
          if (item.title != null) {

            filtered = item.title
              .toLowerCase()
              .includes(vm.search.toLowerCase());
          }
        }

        return filtered;
      });
    },
  },
  data() {
    return {
      loading: true,
      errored: false,
      groups: [],
      selectedGroup: {},
      search: "",
      typeList: [],
      showModalFile: false,
      fileUrl: ""
    };
  },
  created() {
    this.fetchData();
  },
  mounted() {

  },
  methods: {
    fetchData() {
      this.loading = true;

      TaskService.getTaskGroups()
        .then((response) => this.groups = response.data.data)
        .catch((err) => {
          console.log("Videos " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    showGroupDisplay(group) {
        this.$router.push({ name: "Tasks",  params: { group: group } });
        window.scrollTo(0, 0);
    

    },
    setSearchValue(value) {
      this.search = value
    },
    parseTypeDisplay(value) {
      return value.toLowerCase()
    },
    groupHasFile(group) {
      return group.file_url != undefined || group.file_url != null
    },
    openInfo(group) {
      this.showModalFile = true
      this.selectedGroup = group
    },
    shouldDisplay() {
        if (this.currentUser.isOnFree) {
    
            return this.currentAccess.healthAccess;
        } else {
          return true;
        }
    },
  },
  components: {
    Dropdown,
    FilterBar,
    ModalFile,
    UpgradeModal
  },
};
</script>

<style>
</style>
